(function() {
    let attempts = 0;
    const maxAttempts = 20; // Stop looking after 10 seconds (20 * 500ms)

    const checkExist = setInterval(() => {
        const widget = document.querySelector('.kl_reviews__star_rating_widget');
        attempts++;

        if (widget) {
            widget.style.cursor = 'pointer';
            widget.addEventListener('click', function(e) {
                e.preventDefault();

                const targetSection = document.querySelector('.tabs-container');
                const reviewTab = document.querySelector('.tab-header.reviews');

                if (targetSection) {
                    // Optimized Scroll: Accounts for a 100px sticky header
                    const offset = 100;
                    const bodyRect = document.body.getBoundingClientRect().top;
                    const elementRect = targetSection.getBoundingClientRect().top;
                    const elementPosition = elementRect - bodyRect;
                    const offsetPosition = elementPosition - offset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }

                if (reviewTab) {
                    setTimeout(() => reviewTab.click(), 250);
                }
            }, true);

            clearInterval(checkExist);
        } else if (attempts >= maxAttempts) {
            clearInterval(checkExist); // Stop searching to save battery/CPU
        }
    }, 500);


        document.querySelectorAll('.adev-tabs-wrapper .tabs-nav').forEach(tabsNav => {
            const sectionId = tabsNav.dataset.sectionId;
            console.log('sectionId', sectionId);

            tabsNav.addEventListener('click', (event) => {
                const targetHeader = event.target.closest('.tab-header');
                if (!targetHeader) return;

                const newIndex = targetHeader.dataset.tabIndex;

                // Deactivate all headers and panels
                document.querySelectorAll(`.section-${sectionId} .tab-header`).forEach(header => {
                    header.setAttribute('aria-selected', 'false');
                    header.setAttribute('data-active', 'false');
                });
                document.querySelectorAll(`.section-${sectionId} .tab-panel`).forEach(panel => {
                    panel.setAttribute('hidden', '');
                    panel.setAttribute('data-active', 'false');
                });

                // Activate the selected header and corresponding panel
                targetHeader.setAttribute('aria-selected', 'true');
                targetHeader.setAttribute('data-active', 'true');
                const activePanel = document.querySelector(`.section-${sectionId} .tab-panel[data-panel-index="${newIndex}"]`);
                if (activePanel) {
                    activePanel.removeAttribute('hidden');
                    activePanel.setAttribute('data-active', 'true');
                }
            });

        });

})();